import React from 'react';
import { Grid } from '@mui/material';

// Shimmer for the date header section
export const DateHeaderShimmer = () => {
  return (
    <div className="shift-date-header-shimmer">
      <div className="date-range-info">
        <p className="date-range"></p>
      </div>

      <div className="date-header-content">
        {/* Calendar section */}
        <div className="calendar-section">
          <div className="calendar-icon-shimmer"></div>
        </div>

        {/* Service days section */}
        <div className="service-days-section">
          {Array.from({ length: 7 }, (_, i) => (
            <div key={i} className={`service-day-item`}>
              <div className="day-name"></div>
              <div className="day-number"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

// Shimmer for shift details section
export const ShiftDetailsShimmer = () => {
  return (
    <div className="shift-details-main-shimmer">
      {/* Header with title and cost info */}
      <div className="shift-header-shimmer">
        <div className="header-left-content">
          <p className="title-shimmer"></p>
          <p className="subtitle-shimmer"></p>
        </div>
        <div className="header-right-content">
          <p className="cost-shimmer"></p>
          <p className="worksheet-count-shimmer"></p>
        </div>
      </div>

      {/* Shift items container */}
      <div className="shifts-container-shimmer">
        {Array.from({ length: 2 }, (_, dayIndex) => (
          <div key={dayIndex} className="day-group-shimmer">
            {/* Day label (e.g., "Wednesday, Aug 13") */}
            <div className="day-label-shimmer">
              <p className="day-date-text"></p>
            </div>

            {/* Service card */}
            <div className="service-card-shimmer">
              <div className="service-image-shimmer"></div>

              <div className="service-content-shimmer">
                <div className="service-info-left">
                  <p className="service-title"></p>
                  <div className="location-info-shimmer">
                    <div className="location-icon"></div>
                    <p className="location-text"></p>
                  </div>
                </div>

                <div className="service-stats-shimmer">
                  <div className="stat-group">
                    <p className="stat-label"></p>
                    <p className="stat-value"></p>
                  </div>
                  <div className="stat-group">
                    <p className="stat-label"></p>
                    <p className="stat-value"></p>
                  </div>
                  <div className="stat-group">
                    <p className="stat-label"></p>
                    <p className="stat-value"></p>
                  </div>
                  <div className="expand-icon-shimmer"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

// Combined shimmer component
const ShiftPreviewShimmer = () => {
  return (
    <div className="shift-preview-main-shimmer">
      <Grid container spacing={2}>
        <Grid item md={12} xs={12}>
          <DateHeaderShimmer />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 3 }}>
        <Grid item md={12} xs={12}>
          <ShiftDetailsShimmer />
        </Grid>
      </Grid>
    </div>
  );
};

export default ShiftPreviewShimmer;
